import styled from 'styled-components';

export const StyledMonthlyExpenses = styled.div`
    .report-top {
        margin: 25px 0;
    }
    .expenses-subtitle {
        font-size: 20px;
        font-weight: 700;
        margin-bottom: 15px;
        .currency-value {
            color: rgba(55, 54, 71, 0.6);
            font-weight: 400;
            margin-inline-start: 5px;
        }
    }
    .expenses-cards-wrapper {
        display: flex;
        flex-direction: column;
        gap: 23px;
        padding-right: 20px;
        direction: ${({ ltr }) => ltr ? 'ltr' : 'rtl'}
    }
`

export const StyledExpensesCard = styled.div`
    padding: 25px;
    border: 1px solid #6E74FF;
    box-shadow: 0px 3px 34px rgba(89, 102, 137, 0.05);
    border-radius: 25px;
    position: relative;
    .eye-icon {
        position: absolute;
        top: 10px;
        right: 30px;
        cursor: pointer;
    }
    .first-row {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid rgba(216, 210, 255, 0.5);
        margin-bottom: 10px;
        padding-bottom: 10px;     
    }
    
    .second-row {
        display: flex;
        gap: 48px;
    }
    .expenses-info-inner-wrapper {
        display: flex;
        flex-direction: column;
        gap: 8px;
        font-size: 16px;
        
        .outlined-header {
            font-weight: 700;
            text-decoration-line: underline;
        }
        .value {
            color: rgba(55, 54, 71, 0.7);
        }
    }
    .paid-panel {
        background: rgba(255, 255, 255, 0.96);
        border: 1px solid #D8D2FF;
        border-radius: 14px;
        height: 8px;
        width: 70px;
        position: relative;
        &::after {
            content: '';
            border-radius: 14px;
            height: 8px;
            background: linear-gradient(179.97deg, #6D8FFF -24.96%, #8467FF 99.97%), #70A6E8;
            width: ${({ paidPercent }) => paidPercent ? `${paidPercent}%` : ''};
            position: absolute;
            bottom: -1px;
            right: ${({ ltr }) => ltr ? '' : 0};
            left: ${({ ltr }) => ltr ? 0 : ''}
        }
    }
    .buttons-wrapper {
        margin-top: 17px;
        display: flex;
        justify-content: space-between;
        gap: 50px;
        .app-btn {
            width: 100%;
            .icon-btn {
                margin-inline-start: 5px;
            }
        }
        
        .red-btn, .green-btn {
            &:hover {
                background: #fff;
            }
        }
        .red-btn {
            color: ${props => props.theme.red};
            border-color: ${props => props.theme.red};
        }
        .green-btn {
            color: ${props => props.theme.green};
            border-color: ${props => props.theme.green};
        }
    }
` 
